import Vue from "vue"

import distributorRouter from "@/router/distributor"
import supplierRouter from "@/router/supplier"
import config from './config'

const allRouterName = [];

const getName = arr => {
  arr.forEach(item => {
    if (item.name) {
      allRouterName.push(item.name);
    }
    if (item.children && item.children.length > 0) {
      getName(item.children);
    }
  });
};
getName([...distributorRouter, ...supplierRouter]);

allRouterName.forEach(i => {
  Vue.component(config.componentsPrefix + i, () =>
    import("@/components/navTab/view.vue")
  );
});
